import { EventEmitter } from 'events'

export default class Ticker extends EventEmitter {

	static instance

	constructor() {

		if ( Ticker.instance ) return Ticker.instance

		super()
		Ticker.instance = this
		this.update = this.update.bind( this )

		this.raf = requestAnimationFrame( this.update )

	}

	update() {

		this.emit( 'tick' )
		this.raf = requestAnimationFrame( this.update )

	}

}
